import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-add\">\r\n  <path id=\"icon-add_路径_912\" data-name=\"路径 912\" d=\"M24.022,15.869H15.869v8.152H13.152V15.869H5V13.152h8.152V5h2.717v8.152h8.152Z\" transform=\"translate(1.489 1.489)\" />\r\n  <path id=\"icon-add_路径_913\" data-name=\"路径 913\" d=\"M0,0H32V32H0Z\" fill=\"none\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol